/*
 * Cashmere Peel sample cart guard.
 * This script runs in the browser, so a skilled person can bypass it.
 * It is a quick fix only. A server side check is the real fix.
 *
 * Rules: the sample may only be in the cart as a Rebuy gift (_source = Rebuy)
 * with quantity 1. Untagged sample lines are removed. Extra quantity is cut to 1.
 */
(function () {
  var cfg = window.EADEM_SAMPLE;
  if (!cfg || !cfg.enabled || window.__sampleGuardLoaded) return;
  window.__sampleGuardLoaded = true;

  var VARIANT_ID = Number(cfg.variantId);
  var DELAY = 800; // wait for Rebuy and the theme to finish their own cart calls
  var COOLDOWN = 1500; // ignore cart calls right after our own changes
  var GIFT_WAIT = 2500; // time we give Rebuy to add its gift

  var nativeFetch = window.fetch ? window.fetch.bind(window) : null;
  var busy = false;
  var cooldownUntil = 0;
  var timer = null;
  var refreshed = false; // gift refresh happens once per page load

  function log(reason, extra) {
    var detail = { reason: reason, page_url: window.location.href };
    if (extra) for (var k in extra) detail[k] = extra[k];
    console.log('sample_cart_guard', detail);
    if (typeof window.gtag === 'function') window.gtag('event', 'sample_cart_guard', detail);
  }

  function isCartWrite(url) {
    return /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(String(url || ''));
  }

  function schedule() {
    if (busy || Date.now() < cooldownUntil) return;
    clearTimeout(timer);
    timer = setTimeout(check, DELAY);
  }

  function getCart() {
    return nativeFetch('/cart.js', { credentials: 'same-origin' }).then(function (r) {
      return r.json();
    });
  }

  function change(key, quantity) {
    return nativeFetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity }),
    }).then(function (r) {
      return r.json();
    });
  }

  function isTagged(item) {
    return !!(item.properties && item.properties._source === 'Rebuy');
  }

  function sampleLines(cart) {
    return (cart.items || []).filter(function (i) {
      return Number(i.variant_id) === VARIANT_ID;
    });
  }

  function refreshUi() {
    try {
      if (window.__cart && typeof window.__cart.fetchCart === 'function') window.__cart.fetchCart();
      document.dispatchEvent(new CustomEvent('fetchCart'));
    } catch (e) {}
  }

  function check() {
    if (busy) return;
    busy = true;
    var removed = false;
    var changed = false;

    getCart()
      .then(function (cart) {
        var chain = Promise.resolve();
        sampleLines(cart).forEach(function (line) {
          if (!isTagged(line)) {
            chain = chain.then(function () {
              removed = true;
              changed = true;
              log('untagged_line', { quantity: line.quantity });
              return change(line.key, 0);
            });
          } else if (line.quantity > 1) {
            chain = chain.then(function () {
              changed = true;
              log('qty_over_1', { quantity: line.quantity });
              return change(line.key, 1);
            });
          }
        });
        return chain.then(function () {
          return removed;
        });
      })
      .then(function (didRemove) {
        cooldownUntil = Date.now() + COOLDOWN;
        if (changed) refreshUi();
        if (didRemove && !refreshed) {
          // Give Rebuy time to add its own gift. If it did not, refresh once.
          setTimeout(function () {
            getCart()
              .then(function (cart) {
                var hasGift = sampleLines(cart).some(isTagged);
                if (!hasGift && !refreshed) {
                  refreshed = true;
                  log('gift_missing_refresh');
                  refreshUi();
                  try {
                    if (window.Rebuy && window.Rebuy.Cart && typeof window.Rebuy.Cart.fetchCart === 'function') {
                      window.Rebuy.Cart.fetchCart();
                    }
                  } catch (e) {}
                }
              })
              .catch(function () {});
          }, GIFT_WAIT);
        }
      })
      .catch(function () {})
      .then(function () {
        busy = false;
      });
  }

  // Wrap fetch. Our own calls use nativeFetch, so they are not seen here.
  if (nativeFetch) {
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : input && input.url;
      var p = nativeFetch.apply(window, arguments);
      if (isCartWrite(url)) p.then(schedule, function () {});
      return p;
    };
  }

  // Wrap XHR
  if (window.XMLHttpRequest) {
    var open = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      if (isCartWrite(url)) {
        this.addEventListener('loadend', schedule);
      }
      return open.apply(this, arguments);
    };
  }

  // Backup triggers
  document.addEventListener('DOMContentLoaded', schedule);
  window.addEventListener('load', schedule);
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) schedule();
  });
})();
